import { createContext, useState, useEffect} from "react";
import feb1 from '../images/games/febinstructions.png';
import feb2 from '../images/games/feb+winner.png';
import feb3 from '../images/games/feb+credits.png';
import feb4 from '../images/games/fib+gameplay.png';
import A1 from '../images/games/Alchemy1.png';
import A2 from '../images/games/Alchemy2.png';
import A3 from '../images/games/Alchemy3.png';
import A4 from '../images/games/Alchemy4.png';
import A5 from '../images/games/Alchemy5.png';
import A6 from '../images/games/Alchemy6.png';
import O1 from '../images/games/ooze-festation-1.png';
import O2 from '../images/games/ooze-festation-2.png';
import O3 from '../images/games/ooze-festation-3.png';
import O5 from '../images/games/ooze-festation-5.png';
import O6 from '../images/games/ooze-festation-6.png';
import O7 from '../images/games/ooze-festation-7.png';
import O8 from '../images/games/ooze-festation-8.png';
import ED1 from '../images/websites/ED1.png';
import ED2 from '../images/websites/ED2.png';
import ED3 from '../images/websites/ED3.png';
import ED4 from '../images/websites/ED4.png';
import ED5 from '../images/websites/ED5.png';
import ED6 from '../images/websites/ED6.png';
import ED7 from '../images/websites/ED7.png';



export const GallaryContext = createContext({
    currentFebImage: feb1,
    currentAlImage: A1,
    currentOozImage: O1,
    currentEDImage: ED1,
    febImages: [feb1, feb2, feb3, feb4],
    alImages: [A1, A2, A3, A4, A5, A6],
    oozImages: [O1, O2, O3, O5, O6, O7, O8],
    edImages: [ED1, ED2, ED3, ED4, ED5, ED6, ED7]
});

export const GallaryProvider = ({children}) => {
    const [currentFebImage, setCurrentFebImage] = useState(feb1);
    const [currentAlImage, setCurrentAlImage] = useState(A1);
    const [currentOozImage, setCurrentOozImage] = useState(O1);
    const [currentEDImage, setCurrentEDImage] = useState(ED1);
    const [febImages, setFebImages] = useState([feb1, feb2, feb3, feb4]);
    const [alImages, setAlImages] = useState([A1, A2, A3, A4, A5, A6]);
    const [oozImages, setOozImage] = useState([O1, O2, O3, O5, O6, O7, O8]);
    const [edImages, setEDImages] = useState([ED1, ED2, ED3, ED4, ED5, ED6, ED7]);



    const febGallaryPrevious = () => {
        var temp = febImages.indexOf(currentFebImage);
        if(temp == 0){
            temp = febImages.length-1;
        }
        else{
            temp -=1;
        }
        setCurrentFebImage(febImages[temp]);
    };

    const febGallaryNext = () => {

        var temp = febImages.indexOf(currentFebImage);
        console.log(temp);
        if(temp == febImages.length-1){
            temp = 0
        }
        else{
            temp +=1;
            console.log(temp)
        }
        setCurrentFebImage(febImages[temp]);
    }

    const AlGallaryNext = () => {

        var temp = alImages.indexOf(currentAlImage);
        console.log(temp);
        if(temp == alImages.length-1){
            temp = 0
        }
        else{
            temp +=1;
            console.log(temp)
        }
        setCurrentAlImage(alImages[temp]);
    }

    const AlGallaryPrevious = () => {
        var temp = alImages.indexOf(currentAlImage);
        if(temp == 0){
            temp = alImages.length-1;
        }
        else{
            temp -=1;
        }
        setCurrentAlImage(alImages[temp]);
    };
    //oozfestiation
    const OozGallaryPrevious = () => {
        var temp = oozImages.indexOf(currentOozImage);
        if(temp == 0){
            temp = oozImages.length-1;
        }
        else{
            temp -=1;
        }
        setCurrentOozImage(oozImages[temp]);
    };

    const OozGallaryNext = () => {

        var temp = oozImages.indexOf(currentOozImage);
        console.log(temp);
        if(temp == oozImages.length-1){
            temp = 0
        }
        else{
            temp +=1;
            console.log(temp)
        }
        setCurrentOozImage(oozImages[temp]);
    }
    //epiphanydice
    const EDGallaryPrevious = () => {
        var temp = edImages.indexOf(currentEDImage);
        if(temp == 0){
            temp = edImages.length-1;
        }
        else{
            temp -=1;
        }
        setCurrentEDImage(edImages[temp]);
    };

    const EDGallaryNext = () => {

        var temp = edImages.indexOf(currentEDImage);
        console.log(temp);
        if(temp == edImages.length-1){
            temp = 0
        }
        else{
            temp +=1;
            console.log(temp)
        }
        setCurrentEDImage(edImages[temp]);
    }

    const value = {currentFebImage, febGallaryNext, febGallaryPrevious, currentAlImage, AlGallaryNext, AlGallaryPrevious, currentOozImage, OozGallaryNext, OozGallaryPrevious, currentEDImage, EDGallaryNext, EDGallaryPrevious};

    return <GallaryContext.Provider value={value}>{children}</GallaryContext.Provider>
}